import { getMyProfileEndpoint, MyProfile } from 'cpnl-common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';

const { reducer, fetchData } = getSimpleDataFetchSlice<MyProfile, DefaultBusinessMarketApiErrorCode>({
    dataName: 'myProfile',
    fetchCallback() {
        return CpDataApi.get(getMyProfileEndpoint()).then((response) => response.data);
    },
});

export default reducer;
export const fetchMyProfile = fetchData;
